module.exports = __webpack_public_path__ + "img/shake.5288f561.png";